import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useNavigate } from 'react-router-dom';
import './Styling/OrderManual.css';

const Order = () => {
    const { user, isAuthenticated } = useAuth0();
    const [agreed, setAgreed] = React.useState(false);
    const navigate = useNavigate();
    const serverName = "https://api.myemployeemanual.com";

    async function purchase(e){
        e.preventDefault();
        if (!isAuthenticated || !user) {
            alert('Please log in to make a purchase.');
            return;
        }
        if (!agreed) {
            alert('Please agree to the Terms of Service and Privacy Policy before purchasing.');
            return;
        }
        try {
            const formData = new FormData(e.target);
            const state = formData.get('state');
            const stripePromise = loadStripe('pk_live_51R8rrxDhOA29IJXcsTMwDBuzj8crNuQwUvJwKpkNmSuGPrLKOqjxGGowete9qMryKbxatuOkUhRIRe3xHA350x5600CRHgi0Jv');
            const stripe = await stripePromise;
            const startSession = await fetch(`${serverName}/createSession?userID=${user.sub}&price=price_1R9ExaDhOA29IJXcscZS4wao&qty=1&state=${state}`, {
                method: 'POST',
            });
            const sessionID = await startSession.json();
            const result = await stripe.redirectToCheckout({ sessionId: sessionID["sessionId"] });
            if (result.error) console.error('Stripe redirect error:', result.error);
        } catch (error) {
            console.error('Purchase error:', error);
            alert('Error processing purchase. Please try again.');
        }
    }

    if (!isAuthenticated) {
        navigate('/');
        return null;
    }

    return (
        <div className='order'>
            <form className='orderForm' onSubmit={purchase}>
                <p>Notice: Currently we're only serving retail businesses in California. More industries and jurisdictions coming soon.</p>

                <div className='inElem'>
                    <label>State</label>
                    <select name="state">
                        <option value="CA">California</option>
                    </select>
                </div>
                <div className='inElem'>
                    <label>Industry</label>
                    <select name="industry">
                        <option value="retail">Retail</option>
                    </select>
                </div>

                <label className='tosAgree'>
                    <input
                        type="checkbox"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                    />
                    <span>
                        I have read and agree to the{' '}
                        <Link to="/tos" target="_blank" rel="noopener">Terms of Service</Link>
                        {' '}and{' '}
                        <Link to="/privacyPolicy" target="_blank" rel="noopener">Privacy Policy</Link>.
                        My subscription will renew annually only with my affirmative election.
                    </span>
                </label>

                <input
                    className='purchase'
                    type="submit"
                    value="Purchase"
                    disabled={!agreed}
                />

                <p className='noticeAtCollection'>
                    We collect the information above to process your purchase and to generate your employee manual, as described in our <Link to="/privacyPolicy">Privacy Policy</Link>.
                </p>
            </form>
        </div>
    );
}

export default Order;
